import { Field, FieldProps, FormikProps } from 'formik';
import * as React from 'react';
import { FieldRow, Flex, StyledFormGroup, StyledFormSelectFormik } from '../../../../components/shared';
import { Option, PeopleProfileInstitutionFormType } from '../../../../utils/types';
import { InstitutionsCard } from './institutionsCard';
import { validateSAIDNumber } from '../../../../utils';
import { PersonDetailsFormType } from '../forms/PersonDetailsForm';

export type FormType = PersonDetailsFormType & {
  typeId: Option | undefined;
  portal: string;

  careGiverContactNumber: string;
  careGiverName: string;
  careGiverNationalId: string;
  careGiverSurname: string;
  disability: Option | undefined;
  districtId: Option | undefined;
  emisNumber: number | undefined;
  emailAddress: string;
  trackingId: string;

  primaryInstitutionId: Option | undefined;
  institutionIds: Option[];
  associatedInstitutions: PeopleProfileInstitutionFormType[];
};

type Props = {
  formikProps: FormikProps<FormType>;
  userRoles?: any;
};

const FieldsForStudent: React.FC<Props> = props => {
  const { formikProps, userRoles } = props;

  const canLinkInstitutions = ['INSTITUTION_ADMIN', 'INSTITUTION_MEMBER'].some(
    (item: any) => userRoles && userRoles.includes(item)
  );

  return (
    <React.Fragment>
      <FieldRow>
        <Flex direction="row" size="0.5">
          <Field
            name="emailAddress"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormGroup {...field} field={field} form={formikProps} label="Email Address" mr={3} />
            )}
          />
          <Field
            name="trackingId"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormGroup
                {...field}
                field={field}
                form={formikProps}
                label="Tracking ID / Admission Number"
                mr={3}
              />
            )}
          />
        </Flex>
      </FieldRow>
      <FieldRow>
        <Flex direction="row" size="0.25">
          <Field
            name="disability"
            render={({ field }: FieldProps<FormType>) => (
              <StyledFormSelectFormik
                {...field}
                field={field}
                label="Disability"
                form={formikProps}
                options={[
                  { label: 'Yes', value: true },
                  { label: 'No', value: false },
                ]}
                mr={4}
              />
            )}
            // {...values.typeId &&
            //   values.typeId.label === 'Learners' && {
            //     validate: (value: any) => validate(value, 'Identification Type'),
            //   }}
          />
        </Flex>
      </FieldRow>
      <InstitutionsCard
        formikProps={formikProps}
        viewMode={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
        currentInstitutionsOnly={formikProps.values.portal !== 'admin' && !canLinkInstitutions}
      />
      <FieldRow>
        <Field
          name="careGiverName"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Next of Kin Name" mr={4} />
          )}
        />
        <Field
          name="careGiverSurname"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Next of Kin Surname" mr={4} />
          )}
        />
        <Field
          name="careGiverNationalId"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Next of Kin National ID" mr={4} />
          )}
          validate={validateSAIDNumber}
        />
        <Field
          name="careGiverContactNumber"
          render={({ field }: FieldProps<FormType>) => (
            <StyledFormGroup {...field} field={field} form={formikProps} label="Next of Kin Contact Number" mr={4} />
          )}
        />
      </FieldRow>
    </React.Fragment>
  );
};

export default FieldsForStudent;
